import { Table } from "react-bootstrap";
import ComingTableBody from "./ComingTableBody";
import { useTranslation } from "react-i18next";
import ESpinner from "../../others/Spinner";

const ComingTable = ({aComing, setAComing, comingProcess, isLoading = false, editable = true}) => {
    const { t } = useTranslation(['Warehouses']);
    return (<div>

        {!isLoading 
        ?(<div className="crm-table-wrap px-3">
            <Table className="ComingTable table-hover">
                <thead >
                    <tr className="bg-light">
                        <td className="head-name">{t('comingFields.prodName')}</td>
                        <td className="head-price" title={t('labelPrice')}>
                            {t('comingFields.price')}
                        </td>
                        <td className="head-count text-end">{t('comingFields.count')}</td>
                        <td className="head-action">{t('fields.action')}</td>
                    </tr>
                </thead>

                <ComingTableBody
                    comingProcess={comingProcess}
                    aComing={aComing}
                    setAComing={setAComing}
                    editable={editable}/>
            </Table>
        </div>)
        :(<ESpinner/>)}
        </div>
    )
}

export default ComingTable;